import React from "react";
import { useSelectedResult } from "../../../contexts/SelectedResultContext";
import { useParams } from "react-router-dom";
import { getLDSOrderById, getLdsOrder } from "../../../services/fhpService";
import OrganizedTourProfile from "./OrganizedTourProfile";
import { countAdultsAndKids } from "../../../utils/LDSHelpers";
import { useSearch } from "../../../contexts/SearchContext";
import { useAppContext } from "../../../contexts/AppContext";
import { Helmet } from "react-helmet";
import { App } from "antd";

const SavedToursProfile = () => {
  const { notification } = App.useApp();
  const { id } = useParams();
  const {
    setOurSavedLDSOrder,
    ourSavedLDSOrder,
    setSelectedResult,
    updateHandleFeeData,
    handleFeeData,
    setAgentData,
    setRoomsAndPaxInfo,
    setOurPrice,
  } = useSelectedResult();
  const [error, setError] = React.useState(false);

  const { calculateLDSDealFare } = useSearch();
  const { currencyRate } = useAppContext();

  const getLdsData = (dealid, dep_date, ret_date, passengersInfo) => {
    const { totalAdults, totalKids, totalInfant } =
      countAdultsAndKids(passengersInfo);

    getLDSOrderById({
      ldsDealId: dealid,
      depDate: dep_date,
      retDate: ret_date,
      numOfAdults: totalAdults,
      numOfChildren: totalKids,
      numOfInfants: totalInfant,
      deal_type: "OrganizedTour",
    }).then((res) => {
      const status = res.data?.opStatus?.status;
      if (status === "NO_RESULTS") {
        console.log("ERROR: No results");
        setError(true);
        return;
      }
      const deal = res.data.deal;
      const ourPrice = calculateLDSDealFare(deal);
      if (!ourPrice) {
        notification.error({
          message: "שגיאה",
          description: "לא ניתן לחשב מחיר להזמנה זו. נסה שוב מאוחר יותר.",
          placement: "bottomRight",
          duration: 5,
        });
        setError(true);
        return;
      }
      deal.ourPrice = ourPrice;
      setSelectedResult(deal);
    });
  };

  React.useEffect(() => {
    if (!id || !currencyRate) {
      return;
    }
    getLdsOrder({ id })
      .then((res) => {
        if (!res?.data || typeof res.data !== "object") {
          setError(true);
          return;
        }
        const row = res.data;
        setOurSavedLDSOrder(row);
        setAgentData(row.agent ?? null);
        const { passengersinfo, dealid, dep_date, ret_date, ourprice } = row;
        if (!row.order_response || !row.order_response.reservation) {
          getLdsData(dealid, dep_date, ret_date, passengersinfo, "true");
        }
        setRoomsAndPaxInfo(passengersinfo);
        if (row.ourprice?.handleFeeData) {
          const hf = row.ourprice.handleFeeData;
          if (hf.type != null && hf.value != null) {
            updateHandleFeeData(hf.type, hf.value);
          }
        }
        if (ourprice && typeof ourprice === "object") {
          setOurPrice({
            ...ourprice,
            handleFeeData: handleFeeData ?? ourprice.handleFeeData,
          });
        } else {
          setOurPrice(ourprice ?? null);
        }
      })
      .catch((err) => {
        console.log("ERROR: " + err);
        setError(true);
      });
  }, [id, currencyRate]);

  if (error || !id) {
    return (
      <>
        <Helmet>
          <title>הצעה מספר {ourSavedLDSOrder?.dealid || ""}</title>
          <meta
            name="description"
            content={"לקוח יקר, מצורפת הצעת מחיר לעיונך ואישורך"}
          />
          <meta
            property="og:title"
            content={`הצעת מחיר מספר ${ourSavedLDSOrder?.dealid || ""}`}
          />
          <meta property="og:type" content="website" />
          <meta
            property="og:description"
            content={"לקוח יקר, מצורפת הצעת מחיר לעיונך ואישורך"}
          />
          <meta property="og:url" content={window.location.href} />
        </Helmet>
        <div style={{ color: "red", fontSize: 30 }}>
          אירעה שגיאה, אנה נסה שנית מאוחר יותר
        </div>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>הצעה מספר {ourSavedLDSOrder?.dealid || ""}</title>
        <meta
          name="description"
          content={"לקוח יקר, מצורפת הצעת מחיר לעיונך ואישורך"}
        />
        <meta
          property="og:title"
          content={`הצעת מחיר מספר ${ourSavedLDSOrder?.dealid || ""}`}
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:description"
          content={"לקוח יקר, מצורפת הצעת מחיר לעיונך ואישורך"}
        />
        <meta property="og:url" content={window.location.href} />
      </Helmet>
      <OrganizedTourProfile orderSaved={true} ourLdsId={id} />
    </>
  );
};

export default SavedToursProfile;
